<!--
 * @Author: your name
 * @Date: 2022-03-15 14:24:12
 * @LastEditTime: 2022-03-28 19:41:27
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%
 * @FilePath: \Do-network\src\views\pc\intro\Econimucs.vue
-->
<template>
  <div class="Economics">
    <div class="Economics-all">
      <div class="Economics-heater">
        <p>{{ $t("Eco.ecoTitle") }}</p>
      </div>
      <div class="Economics-Technology">
        <p>{{ $t("Eco.ecoWhat") }}</p>
      </div>
      <div class="Economics-DoNetwork">
        <p>
          {{ $t("Eco.ecoDetail") }}
        </p>
      </div>
      <div class="clearfix">
        <div class="Trustor-all Trustor">
           <div class="Trustor-reward">
            <p class="Trustor-p">{{ $t("Eco.Conditions") }}</p>
            <p class="Trustor-p2 p-buttom">
              {{ $t("Eco.ConditionsDetail") }}
            </p>
          </div>
          <div class="Trustor-imgs">
            <p class="Trustor-p">{{ $t("Eco.rewards") }}</p>
            <p class="Trustor-p2 p-buttom">
            {{ $t("Eco.rewardDetails") }}
            </p>
          </div>
          
          <div class="Trustor-imgs">
            <p class="Trustor-p">{{ $t("Eco.rule") }}</p>
            <p class="Trustor-p2 rule-buttom">
              {{ $t("Eco.ruleDetail") }}
            </p>
          </div>
        </div>
        <div class="Trustor-imges Trustor">
          <div class="Trustor-imges1">
            <img src="../../../assets/pc/intro/Trustor reward.svg" alt="" class="img1" />
          </div>
          <div class="Trustor-imges1 Trustor-imges2">
            <img src="../../../assets/pc/intro/Trustor rule.svg" alt="" class="img2" />
          </div>
        </div>
      </div>
      <div class="footer-p">
        <p>
          {{ $t("Eco.tip") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
div {
  box-sizing: border-box;
}
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
.Economics {
  background: url(../../../assets/pc/intro/back.png) no-repeat center / 100%
    100%;
    background-size: 100%;
  // background-position: 0 300px;
  padding-bottom: 307px;
}
.Economics-all {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding-left: 20px;
  padding-top: 231px;
  .Economics-heater {
    font-size: 80px;
    font-family: Poppins-Black, Poppins;
    font-weight: 900;
    color: #000000;
    line-height: 103px;
    -webkit-background-clip: text;
    margin-bottom: 45px;
  }
  .Economics-Technology {
    font-size: 24px;
    font-family: Poppins-Medium, Poppins;
    font-weight: 500;
    color: #000000;
    line-height: 28px;
    -webkit-background-clip: text;
  }
  .Economics-DoNetwork {
    font-size: 18px;
    color: #61666b;
    line-height: 29.6px;
    margin-top: 25px;
    margin-bottom: 146px;
    font-family: Poppins-Medium, Poppins;
    font-weight: 500;
    -webkit-background-clip: text;
  }
  .Trustor {
    float: left;
    //
    p {
      width: 594px;
      margin-right: 240px;
    }
  }
  .Trustor-p {
    font-size: 18px;
    font-family: Poppins-SemiBold, Poppins;
    font-weight: 600;
    color: #2c1d1a;
    line-height: 31px;
    -webkit-background-clip: text;
  }
  .Trustor-p2 {
    width: 594px;
    height: 72px;
    font-size: 14px;
    font-family: Poppins-Medium, Poppins;
    font-weight: 500;
    color: #737582;
    line-height: 24px;
    -webkit-background-clip: text;
  }
  .p-buttom {
    margin-bottom: 80px;
  }
  .rule-buttom {
    width: 594px;
    height: 96px;
  }
  .Trustor-reward {
    margin-top: 5px;
  }
  .Trustor-imges1 {
    width: 201.66px;
    height: 222.64px;
    // background: #000;
    text-align: center;
    margin-bottom: 9px;
    .img1{
      width: 201.66px;
      height: 143.63px;
    }
    .img2{
      width: 202px;
      height: 157.32px;
    }
  }
  .Trustor-imges2 {
    margin-top: 120px;
  }
  .footer-p {
    width: 100%;
    margin-top: 80px;
    font-size: 14px;
    color: #4573e7;
    line-height: 24px;
    font-family: Poppins-Medium, Poppins;
    -webkit-background-clip: text;
    p {
      width: 100%;
    }
  }
}
</style>
